<div class="core-ui-input-text" [class.core-ui-input-text--block]="block"
    [class.core-ui-input-text--icon-left]="icon && iconPosition === 'left'"
    [class.core-ui-input-text--icon-right]="icon && iconPosition === 'right'" [attr.data-size]="size">

    <div 
        class="core-ui-input-text__control" 
        [class.is-filled]="isFilled" 
        [class.is-active]="isFocused"
        [class.has-prefix]="prefixText"
        [class.has-icon-left]="icon && iconPosition === 'left'"
        [class.has-icon-right]="icon && iconPosition === 'right'"
        [class.is-disabled]="disabled"
        [class.is-readonly]="readOnly"
        [class.is-error]="error"
    >

        <div class="core-ui-input-text__input-wrapper">

            <ng-container *ngIf="icon && iconPosition === 'left'">
                <div class="core-ui-input-text__icon-left">
                    <core-ui-icon [size]="sizeIcon" [name]="icon" [color]="iconColor"></core-ui-icon>
                </div>
            </ng-container>

            <label class="core-ui-input-text__search-input-text">
                <span *ngIf="label" class="core-ui-input-text__label">{{ label }}</span>
                <span *ngIf="prefixText" class="core-ui-input-text__prefix">{{ prefixText }}</span>

                <input
                    class="core-ui-input-text__input-text"
                    [type]="type"
                    [inputMode]="inputMode === 'amount' ? 'decimal' : undefined"
                    [placeholder]="placeholder"
                    [disabled]="disabled"
                    [readonly]="readOnly"
                    [attr.aria-readonly]="readOnly"
                    [attr.aria-invalid]="error"
                    [attr.aria-autocomplete]="ariaAutocomplete"
                    [attr.aria-controls]="ariaControls"
                    [attr.aria-expanded]="ariaExpanded"
                    [attr.aria-activedescendant]="ariaActiveDescendant"
                    [value]="value"
                    (input)="handleInput($event)"
                    (blur)="handleBlur()"
                    (keydown.enter)="handleEnter()"
                    (focus)="handleFocus()"
                    (keydown)="handleKeydown($event)"
                />
            </label>

            <ng-container *ngIf="icon && iconPosition === 'right'">
                <div class="core-ui-input-text__icon-right">
                    <core-ui-icon [size]="sizeIcon" [name]="icon" [color]="iconColor"></core-ui-icon>
                </div>
            </ng-container>

        </div>
    </div>
</div>
